module.exports = __webpack_public_path__ + "img/jf_home_13.e1071562.jpg";